import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import get from 'lodash.get';
import { isPreview, getTrackingObj, getNoteByDevice } from './messageHelpers';
import style from './MessageBanner-style.scss';

//getDangerousProps and getChildren must be used together and only ONE of them will be rendered
const getDangerousProps = value =>
    typeof value === 'string'
        ? {
              dangerouslySetInnerHTML: {
                  __html: value,
              },
          }
        : {};
const getChildren = value => (typeof value !== 'string' ? value : null);

const MessageBannerItem = ({ messageItem }) => {
    const { message, cta } = get(getNoteByDevice(messageItem), 'content', {});

    const _trackCtaClick = () => {
        if (!isPreview()) {
            trackEvent(
                getTrackingObj({
                    messageItem,
                    action: 'banner cta clicked',
                })
            );
        }
    };

    return (
        <div className={style.itemWrapper}>
            <span {...getDangerousProps(message)}>{getChildren(message)}</span>{' '}
            {cta && (
                <a
                    className={style.ctaLink}
                    href={cta.url}
                    onClick={_trackCtaClick}
                    rel="noopener noreferrer"
                    target="_blank"
                    {...getDangerousProps(cta.text)}
                >
                    {getChildren(cta.text)}
                </a>
            )}
        </div>
    );
};

MessageBannerItem.propTypes = {
    messageItem: PropTypes.object.isRequired,
};

export default MessageBannerItem;
